// main.js
import { createApp } from 'vue';
import { createPinia } from 'pinia';
import App from './App.vue';
import router from './router';

import Vant from 'vant';
import 'vant/lib/index.css';
import './assets/main.css';

import ElementPlus from 'element-plus';
import 'element-plus/dist/index.css';
// vant的 showtoast 与popup 有冲突，需要在末尾再明文引入一次；
import 'vant/es/toast/style';
import { StatService } from '@/mechanism/statService';


// import VConsole from 'vconsole';
// const vConsole = new VConsole();
// console.log('vConsole 已启动', vConsole);


import * as echarts from 'echarts' // 1. 引入 echarts

// import '@/apps/file_processor/style.css'

// 2. 挂载到 window 对象上，供动态沙箱全局调用
window.echarts = echarts;


const app = createApp(App);

app.use(createPinia());
app.use(router);

// 【修改点 3】告诉 Vue 使用 Vant
app.use(Vant);
app.use(ElementPlus);

app.use(StatService, {router})

app.mount('#app');
